module.exports = __webpack_public_path__ + "static/cube-3e037f3f2b79aa64ff9c6ac33c4cd704.gif";